/**
 * components/ui/InfoBox.jsx
 * Contextual notice box used throughout the settings panels.
 *
 * variant="info"  — blue, circle-i icon  (default)
 * variant="tip"   — amber, triangle-warning icon
 */

export function InfoBox({ variant = "info", className = "", children }) {
    const isInfo = variant === "info";
    return (
        <div
            className={`flex items-start gap-2 rounded-md border px-3 py-2.5 text-xs ${
                isInfo
                    ? "border-blue-200 bg-blue-50 text-blue-800"
                    : "border-amber-200 bg-amber-50 text-amber-800"
            }${className ? " " + className : ""}`}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`mt-0.5 size-3.5 shrink-0 ${
                    isInfo ? "text-blue-500" : "text-amber-500"
                }`}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {isInfo ? (
                    <>
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </>
                ) : (
                    <>
                        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                        <line x1="12" y1="9" x2="12" y2="13" />
                        <line x1="12" y1="17" x2="12.01" y2="17" />
                    </>
                )}
            </svg>
            <span>{children}</span>
        </div>
    );
}
